// extracted by mini-css-extract-plugin
export default {"root":"xZCNfFhYLueZyiFMlHjL","action-footer":"cfrRt_BZWM9W7HqukJzU","action-footer__btn-cancel":"Oo2p6c5WRrD2rgl6CLa_"};